<h2 mat-dialog-title>{{ data.label }}</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ data.label }}</mat-label>

      <mat-select formControlName="states" multiple>
        <mat-select-trigger>
          <mat-chip-set>
            @for (stateCode of form.get('states')?.value ?? []; track stateCode) {
              <mat-chip-row (removed)="removeState(stateCode)">
                {{ stateCode }}

                <button matChipRemove type="button">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-set>
        </mat-select-trigger>

        @for (state of states; track state.code) {
          <mat-option [value]="state.code">
            {{ state.code }} - {{ state.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="clear()">Clear</button>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="submit">Save</button>
  </mat-dialog-actions>
</form>